import { get, toArray, random } from "../../../utils";
import { urlToFile } from "../../../utils/upload/uploadFile";

/**
 * 文件转urls
 *
 * @param {*} file
 * @param {*} ossUrl
 * @param {*} uploadFormList
 * @returns
 */
export const fileToUrl = function (file, ossUrl, uploadFormList) {
  if (file.url) {
    return file.url;
  }
  const uploadFormObj = uploadFormList.find((u) => u.uid === file.uid);
  const uploadForm = get(uploadFormObj, "form", {});
  return {
    url: `${ossUrl}/${uploadForm.key}`,
    ...file,
  };
};

/**
 * oss类型的form表单值转换通用函数
 *
 * @param {*} ossUrl
 * @param {*} filterList
 * @param {*} uploadFormList
 * @returns
 */
export const ossValueFromHandle = function (
  ossUrl,
  filterList,
  uploadFormList
) {
  const fileArray = toArray(filterList).map((file) =>
    fileToUrl(file, ossUrl, uploadFormList)
  );
  const fileList_ = fileArray.map((urlObj, index) => {
    if (typeof urlObj === "string") {
      return urlToFile(urlObj, -1 * index);
    }
    return urlObj;
  });
  const completeUrls = fileList_.filter((f) => f.status === "done");
  const result = { urls: completeUrls.map((f) => f.url), completeUrls };
  return result;
};



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/YxUpload/tools.js